// Styles for PasswordInput go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledPasswordInput = styled.div`
  .m-input-field {
    input {
      caret-color: ${baseVariables.color['neutral40']};
      &::-ms-reveal {
        display: none;
      }
    }
    &.is-error {
      &:focus-within {
        label {
          color: ${baseVariables.color.alert50};
        }
      }
      input:focus {
        box-shadow: none;
        outline: 0;
      }
      .icon-visibility-off,
      .icon-visibility {
        font-size: ${baseVariables.font.fontXl};
      }
    }
    &.disabled {
      label {
        color: ${baseVariables.color.alert20};
      }
      input {
        border-color: ${baseVariables.color.alert20};
        outline: 0;
        color: ${baseVariables.color.neutral50} !important;
        &:focus {
          outline: 0;
          border-color: ${baseVariables.color.alert20};
          box-shadow: none;
        }
      }
    }
  }
  .m-input-text-field {
    .icon-visibility-off,
    .icon-visibility {
      font-size: ${baseVariables.font.fontXl};
    }
    .trailing-element {
      bottom: ${toRem(12)};
    }
    .is-error {
      .trailing-element {
        bottom: ${toRem(37)};
      }
    }
  }
  .password-valid-check {
    position: absolute;
    left: initial;
    right: ${toRem(34)};
    &__inline {
      top: ${toRem(12)};
    }
    &__standard {
      top: ${toRem(10)};
    }
  }
  .green-check {
    color: ${baseVariables.color.alert30} !important;
  }
  .red-clear {
    color: ${baseVariables.color.alert50} !important;
  }
  .fade-icon {
    color: ${baseVariables.color.neutral30} !important;
  }
  .m-input-field {
    &.is-disabled {
      label {
        z-index: 1;
      }
    }
    caret-color: inherit; // This is to override transparent caret color
  }
  .m-input-text-field
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border: ${baseVariables.color.neutral30} solid ${toRem(1)};
    border-radius: ${toRem(8)};
    color: ${baseVariables.color.base10};
    font-size: ${baseVariables.font.fontM};
    line-height: ${baseVariables.font.lineHeightL};
    padding: ${toRem(26)} ${toRem(16)} ${toRem(8)};
    height: ${toRem(52)};
  }
  .m-input-text-field.is-error
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']):focus {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='password']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio'])
    + span {
    color: ${baseVariables.color.alert50};
    font-size: ${baseVariables.font.fontXs};
    font-weight: ${baseVariables.font.fontWeightRegular};
    line-height: ${baseVariables.font.lineHeightS};
  }

  .error-label,
  .error-label * {
    font-size: ${baseVariables.font.fontXs};
    color: ${baseVariables.color.alert50} !important;
  }
  .password-checks {
    &__description {
      @media ${baseVariables.mediaQuery.md} {
        white-space: nowrap;
      }
    }
  }
  input[type='password']::-ms-reveal,
  input[type='password']::-ms-clear {
    display: none;
  }
`;

export const StyledInputTextFieldNumber = styled.div`
  .m-input-text-field
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border: ${baseVariables.color.neutral30} solid ${toRem(1)};
    border-radius: ${toRem(8)};
    color: ${baseVariables.color.base10};
    font-size: ${baseVariables.font.fontM};
    line-height: ${baseVariables.font.lineHeightL};
    padding: ${toRem(26)} ${toRem(16)} ${toRem(8)};
    height: ${toRem(52)};
  }
  .m-input-text-field.is-error
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']):focus {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='number']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio'])
    + span {
    color: ${baseVariables.color.alert50};
    font-size: ${baseVariables.font.fontXs};
    font-weight: ${baseVariables.font.fontWeightRegular};
    line-height: ${baseVariables.font.lineHeightS};
  }
`;

export const StyledInputTextFieldEmail = styled.div`
  .m-input-text-field
    input[type='email']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border: ${baseVariables.color.neutral30} solid ${toRem(1)};
    border-radius: ${toRem(8)};
    color: ${baseVariables.color.base10};
    font-size: ${baseVariables.font.fontM};
    line-height: ${baseVariables.font.lineHeightL};
    padding: ${toRem(26)} ${toRem(16)} ${toRem(8)};
    height: ${toRem(52)};
  }
  .m-input-text-field.is-error
    input[type='email']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='email']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']):focus {
    border-color: ${baseVariables.color.alert50};
  }
  .m-input-text-field.is-error
    input[type='email']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio'])
    + span {
    color: ${baseVariables.color.alert50};
    font-size: ${baseVariables.font.fontXs};
    font-weight: ${baseVariables.font.fontWeightRegular};
    line-height: ${baseVariables.font.lineHeightS};
  }
`;
